import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class HistoryLookupRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getTableOptions(): Observable<Core.IndexedHistoryTableModel[]> {
        return this.httpGet<Core.IndexedHistoryTableModel[]>(`/api/diagnostics/historyLookup/tables`);
    }

    lookupHistoryAccountNumber(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultAccountNumberModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/AccountNumber`, searchModel);
    }

    lookupHistoryAddress(searchModel: Core.HistoryLookupSearchModel): Observable<Core.HistoryResultAddressModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/Address`, searchModel);
    }

    lookupHistoryClientServiceResponsibility(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultClientServiceResponsibilityModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/ClientServiceResponsibility`, searchModel);
    }

    lookupHistoryCompany(searchModel: Core.HistoryLookupSearchModel): Observable<Core.HistoryResultCompanyModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/Company`, searchModel);
    }

    lookupHistoryContact(searchModel: Core.HistoryLookupSearchModel): Observable<Core.HistoryResultContactModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/Contact`, searchModel);
    }

    lookupHistoryGLAccount(searchModel: Core.HistoryLookupSearchModel): Observable<Core.HistoryResultGLAccountModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/GLAccount`, searchModel);
    }

    lookupHistoryParcel(searchModel: Core.HistoryLookupSearchModel): Observable<Core.HistoryResultParcelModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/Parcel`, searchModel);
    }

    lookupHistoryParcelAssessmentClass(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultParcelAssessmentClassModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/ParcelAssessmentClass`, searchModel);
    }

    lookupHistoryParcelCollector(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultParcelCollectorModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/ParcelCollector`, searchModel);
    }

    lookupHistoryParcelCollectorPaymentOption(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultParcelCollectorPaymentOptionModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/ParcelCollectorPaymentOption`, searchModel);
    }

    lookupHistoryParcelCollectorTaxAuthority(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultParcelCollectorTaxAuthorityModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/ParcelCollectorTaxAuthority`, searchModel);
    }

    lookupHistoryParcelDescriptor(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultParcelDescriptorModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/ParcelDescriptor`, searchModel);
    }

    lookupHistorySite(searchModel: Core.HistoryLookupSearchModel): Observable<Core.HistoryResultSiteModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/Site`, searchModel);
    }

    lookupHistorySiteDescriptor(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultSiteDescriptorModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/SiteDescriptor`, searchModel);
    }

    lookupHistoryTaxAuthority(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultTaxAuthorityModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/TaxAuthority`, searchModel);
    }

    lookupHistoryTaxRateArea(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultTaxRateAreaModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/TaxRateArea`, searchModel);
    }

    lookupHistoryTransaction(
        searchModel: Core.HistoryLookupSearchModel,
    ): Observable<Core.HistoryResultTransactionModel[]> {
        return this.httpPost(`/api/diagnostics/historyLookup/Transaction`, searchModel);
    }
}
